{
  "id": "skirmish_02",
  "name": "Skirmish-02",
  "mode": "HOTSEAT_2P",
  "ruleset": "OFFICIAL_SKIRMISH",
  "objective": "Oficiální cíl: soupeř prohrává, když mu nezůstane žádná figurka.",
  "randomStart": true,
  "credits": {"EFA": 20, "REDCAT": 20},
  "terrain": [
    "VMVMVMVHVMVMVMVMVMVMV",
    "MMMMMMMMWMMMWHMMMMMMM",
    "MMMMMMGWWGGGWWGMMMMMM",
    "MMMMMMMWMMMMMWMMMMMMM",
    "MMMMMMWMGMMMMMWMMMMMM",
    "MMMMMWWMMMMMMMWWMGMMM",
    "GMHWMWMMHMMMGMMWMWMMH",
    "WWWMWMMMMMGMMMMMWMWWW",
    "MMGMMMGMMMMMMMHMMGGMM"
  ],
  "bridges": [
    [6, 4], [5, 5], [14, 4], [15, 5]
  ],
  "ore": [
    [9, 0], [11, 0], [13, 0],
    [7, 1], [9, 1], [10, 1], [11, 1],
    [1, 6], [19, 6],
    [9, 7], [10, 7], [11, 7],
    [1, 8], [2, 8], [9, 8], [10, 8], [11, 8], [18, 8], [19, 8]
  ],
  "pieces": [
    {"type": "MCV", "owner": "EFA", "col": 0, "row": 1},
    {"type": "MCV", "owner": "REDCAT", "col": 20, "row": 1}
  ]
}
